module.exports = __webpack_public_path__ + "01_bob_black.f994d7ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_bob_black.png
// module id = SjsH
// module chunks = 0